namespace Gordic.Epk.WebControls {

    export interface GEpkSignOpt {
        casoveRazitko: boolean,
        serCisloEpk: number,
        async?: boolean
    }

    export interface IEpkAttachFileInfo {
        Ixp: string,
        Guid: string,
        Filename: string,
        TxtTitulek: string,
        TxtPopis: string
    }

    /** parametry k vyřízení v EPK */
    export interface IVyrizeniEpkParams {
        /** identifikátor dokumentu */
        ixp: string;
        /** ser. číslo dokumentu */
        serCislo: number;
        /** šablona elektronických podpisů */
        ixsDpo: string,
        /** typ požadavku žádosti */
        typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk;
        /** výběr způsobu vyřízení */
        zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum;
        /** zobrazit dialog důvodu vyřízení (zobrazit či ne) */
        duvodVyrizeni: boolean,
        /** přidat časové razítko k obrazu */
        casoveRazitko: boolean,
        /** přidat časové razítko k přílohám */
        casoveRazitkoPrilohy: boolean,
        /** podepsat obraz */
        podepsatObraz: boolean,
        /** podepsat přílohy */
        podepsatPrilohy: boolean,
        /** provést před podepsáním konverzi */
        predPodepsanimKonvertovat: boolean,
        /** provést konverzi příloh */
        zkonvertovatPrilohy: boolean,
        /** provést podepsání i příloh, které nejsou PDF formátu */
        podepsatPrilohyNePdf: boolean,
        /** informace o certifikátu */
        certInfo?: CertInfo,
        /** připojená soubor k vyřízení */
        attachFileInfo?: IEpkAttachFileInfo | null,
        /** předaný guid GFRM interního formuláře, pokud je k dispozici (19.1.2022) */
        guidGFRM?: string
    }

    /**
     * zpracuji exception a nevyskočí chybové hlášení
     * 
     * @param {any} reason objekt chyby
     * @param {boolean} multiSettlement stav, jestli mam handlovat
     * @param {string} where kde došlo k chybě
     * @returns {string} ttextový popis "chyby"
     */
    export function handleException(reason: any, where?: string, multiSettlement?: boolean): string {
        var baseMessage: string = "";
        if (reason == null || reason.responseJSON == null) {
            //RC 32000485 : Došlo k neočekávané chybě.
            baseMessage = "jres:32000485" + " - " + where;
        }
        else {
            var handled = multiSettlement === true ? true: false;
            // pokud to jde, ohandluji chybu
            reason.responseJSON.exception.handled = handled; // false
            baseMessage = reason.responseJSON.exception.baseMessage;
        }
        return baseMessage;
    }


    /**
    * zpracuji exception a nevyskočí chybové hlášení (async)
    */
    export function handleExceptionAsync(exceptionResult?: any/*Async.GJQExceptionResult*/, where?: string, handled?: boolean) {
        var output: { baseMessage: string, longMessage: string } = { baseMessage: "", longMessage: "" };
        if (exceptionResult == null || exceptionResult.exception == null || exceptionResult.exception.baseMessage == null) {
            output.baseMessage = "jres:32000485" + " - " + where; //RC 32000485 : Došlo k neočekávané chybě.
        }
        else {
            // pokud to jde, ohandluji chybu
            exceptionResult.exception.handled = handled; // false
            output.baseMessage = exceptionResult.exception.baseMessage;
        }
        if (exceptionResult != null && exceptionResult.exception != null && exceptionResult.exception.longMessage != null) {
            output.longMessage = exceptionResult.exception.longMessage;
        }
        return output;
    }

}